// To use store from vue pass this.$store in the method you want to call and then from here you can console.log(store.getters.getCurrentJoke)
//const dsteem = require('@hiveio/dhive'); // Require just what you need
//import dhive from '@hiveio/dhive';
let stream;
const dsteem = window.dhive;

var store;
//var user;

//var watchlist;
//var market_map;
//var reference_grouped_buy;


export function set_store(store_ref) {
    store = store_ref;
}


export async function on_load() {
    // Redirect people from the old site
    if (document.URL.split("/")[2] === "splinteralert.web.app") {
        alert("We are moving to https://splinteralert.com, please start using that link instead.\nYou will now be redirected to the correct domain.");
        //https://api.countapi.xyz/get/splinteralert/redirects
        fetch('https://api.countapi.xyz/hit/splinteralert/redirects');
        window.location.replace("https://splinteralert.com");
    }

    let opts = {};

    //connect to production server
    opts.addressPrefix = 'STM';
    opts.chainId =
        'beeab0de00000000000000000000000000000000000000000000000000000000';

    //connect to server which is connected to the network/production
    store.hive_client = new dsteem.Client(["https://anyx.io", "https://hived.splinterlands.com", "https://hived-2.splinterlands.com", "https://api.openhive.network", "https://api.hive.blog", "https://d36mxiodymuqjm.cloudfront.net/"]); //

    store.user = {
        username: '',
        balance: []
    };

    update_usd_dec();
    setInterval(function () { update_usd_dec(); }, 20000);

    // Get reference date
    //const data = await get_data(1);
    store.last_dates = [];
    store.last_dates['list_buy'] = Date.now() //string_to_date(data[0][0].created_date);
    store.last_dates['list_rent'] = Date.now() //string_to_date(data[1][0].created_date);
    store.last_dates['sold_buy'] = Date.now() //string_to_date(data[2][0].created_date);
    store.last_dates['sold_rent'] = Date.now() //string_to_date(data[3][0].created_date);

    store.refresh_nums = [];

    store.watchlist = [];
    store.market_map = [];
    store.reference_grouped = [];
    store.reference_grouped['buy'] = await get_hashed_grouped_market('buy');
    store.reference_grouped['rent'] = await get_hashed_grouped_market('rent');

    store.settings = await (await fetch("https://api.splinterlands.io/settings")).json();

    store.audio = [];
    store.audio['alert'] = new Audio('https://notificationsounds.com/storage/sounds/file-sounds-1147-that-was-quick.mp3');  // sms ringtone page 2
    store.audio['success'] = new Audio('https://notificationsounds.com/storage/sounds/file-sounds-1085-definite.mp3');      // sms ringtones page 5
    store.audio['fail'] = new Audio('https://notificationsounds.com/storage/sounds/file-sounds-1111-to-the-point.mp3');     // sms ringtones page 5

    // Resize event handler
    window.addEventListener('resize', function(event) {
        let font_size = parseFloat(window.getComputedStyle(document.body, null).getPropertyValue('font-size'));
        let width = window.innerWidth;
        let em = width / font_size;
        if (em > 56.25 && store.user.username != "") {
            $('#nav-user').css({'display': 'flex'});
        } else {
            $('#nav-user').css({'display': 'none'});
        }
        if (em <= 37.5) { // Phone
            $('#buy_head_change').text("%");
            $('#buy_head_USD').text("$");
            $('#rent_head_pow').text("Pow");
            $('#rent_head_USD').text("$");
        } else {
            $('#buy_head_change').text("Change");
            $('#buy_head_USD').text("Price $");
            $('#rent_head_pow').text("Power");
            $('#rent_head_USD').text("Price $");
        }
    }, true);

    // TODO: local storage implementation here

    // Timers //
    //setInterval(update_market, 3000);
}


export function on_load_tables() {
    // Reactive corrections
    let font_size = parseFloat(window.getComputedStyle(document.body, null).getPropertyValue('font-size'));
    let width = window.innerWidth;
    let em = width / font_size;
    if (em <= 37.5) { // Phone
        $('#buy_head_change').text("%");
        $('#buy_head_USD').text("$");
        $('#rent_head_pow').text("Pow");
        $('#rent_head_USD').text("$");
    }

    // Load variables
    //let buy_currency = localStorage['buy_currency'] || 'defaultValue';
    load_ui('buy');
    load_ui('rent');

    //setInterval(function () { new_refresh_watchlist(); }, 3000);
    try {
        start_stream();
    } catch(err) {console.log(err);}
    setInterval(function() { refresh_reference(); }, 30000);
}


export function on_unload_tables() {
    save_ui('buy');
    save_ui('rent');
}


function save_ui(prefix) {
    // Currency
    localStorage[`${prefix}_currency`] = $(`#${prefix}_currency-dec`).prop('checked') ? 'DEC' : 'CREDITS';
    // Sound
    localStorage[`${prefix}_sound-alert`] = $(`#${prefix}_sound-alert`).prop('checked');

    // Change
    localStorage[`${prefix}_filter-change`] = $(`#${prefix}_filter-change`).prop('checked');
    localStorage[`${prefix}_change-min`] = $(`#${prefix}_filter-change-min`).val();

    // Price
    localStorage[`${prefix}_filter-price`] = $(`#${prefix}_filter-price`).prop('checked');
    localStorage[`${prefix}_filter-price-min`] = $(`#${prefix}_filter-price-min`).val();
    localStorage[`${prefix}_filter-price-max`] = $(`#${prefix}_filter-price-max`).val();

    // League
    /*localStorage[`${prefix}_league-bronze`] = $(`#${prefix}_league-bronze`).prop('checked');
    localStorage[`${prefix}_league-silver`] = $(`#${prefix}_league-silver`).prop('checked');
    localStorage[`${prefix}_league-gold`] = $(`#${prefix}_league-gold`).prop('checked');
    localStorage[`${prefix}_league-diamond`] = $(`#${prefix}_league-diamond`).prop('checked');
    localStorage[`${prefix}_league-champion`] = $(`#${prefix}_league-champion`).prop('checked');*/

    // Foil
    localStorage[`${prefix}_foil-standard`] = $(`#${prefix}_foil-standard`).prop('checked');
    localStorage[`${prefix}_foil-gold`] = $(`#${prefix}_foil-gold`).prop('checked');

    // Edition
    localStorage[`${prefix}_edition-alpha`] = $(`#${prefix}_edition-alpha`).prop('checked');
    localStorage[`${prefix}_edition-beta`] = $(`#${prefix}_edition-beta`).prop('checked');
    localStorage[`${prefix}_edition-promo`] = $(`#${prefix}_edition-promo`).prop('checked');
    localStorage[`${prefix}_edition-reward`] = $(`#${prefix}_edition-reward`).prop('checked');
    localStorage[`${prefix}_edition-untamed`] = $(`#${prefix}_edition-untamed`).prop('checked');
    localStorage[`${prefix}_edition-dice`] = $(`#${prefix}_edition-dice`).prop('checked');
    //localStorage[`${prefix}_edition-chaos`] = $(`#${prefix}_edition-chaos`).prop('checked');

    // Rarity
    localStorage[`${prefix}_common`] = $(`#${prefix}_common`).prop('checked');
    localStorage[`${prefix}_rare`] = $(`#${prefix}_rare`).prop('checked');
    localStorage[`${prefix}_epic`] = $(`#${prefix}_epic`).prop('checked');
    localStorage[`${prefix}_legendary`] = $(`#${prefix}_legendary`).prop('checked');

    if (prefix === 'rent') {
        localStorage['rent_days'] = $('#rent_days').val();
    }
}


function load_ui(prefix) {
    // First time
    if (localStorage[`${prefix}_currency`] == undefined)
        return

    // Currency
    if (localStorage[`${prefix}_currency`] === "DEC") {
        document.querySelector(`#${prefix}_currency-dec`).checked = true;
        document.querySelector(`#${prefix}_currency-credits`).checked = false;
    } else {
        document.querySelector(`#${prefix}_currency-dec`).checked = false;
        document.querySelector(`#${prefix}_currency-credits`).checked = true;
    }

    // Sound
    document.querySelector(`#${prefix}_sound-alert`).checked = localStorage[`${prefix}_sound-alert`] === 'true' ? true : false;

    // Change
    if (localStorage[`${prefix}_filter-change`] === 'true' && parseFloat(localStorage[`${prefix}_change-min`])) {
        document.querySelector(`#${prefix}_filter-change`).checked = true;
        document.querySelector(`#${prefix}_filter-change-min`).value = parseFloat(localStorage[`${prefix}_change-min`]);
    } else {
        document.querySelector(`#${prefix}_filter-change`).checked = false;
    }

    // Price
    let price_min = parseFloat(localStorage[`${prefix}_filter-price-min`]);
    let price_max = parseFloat(localStorage[`${prefix}_filter-price-max`]);
    if (localStorage[`${prefix}_filter-price`] === 'true' && price_min && price_max && price_min < price_max) {
        document.querySelector(`#${prefix}_filter-price`).checked = true;
        document.querySelector(`#${prefix}_filter-price-min`).value = price_min;
        document.querySelector(`#${prefix}_filter-price-max`).value = price_max;
    } else {
        document.querySelector(`#${prefix}_filter-price`).checked = false;
    }

    // Foil
    document.querySelector(`#${prefix}_foil-standard`).checked = localStorage[`${prefix}_foil-standard`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_foil-gold`).checked = localStorage[`${prefix}_foil-gold`] === 'true' ? true : false;

    // League
    /*document.querySelector(`#${prefix}_league-bronze`).checked = localStorage[`${prefix}_league-bronze`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_league-silver`).checked = localStorage[`${prefix}_league-silver`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_league-gold`).checked = localStorage[`${prefix}_league-gold`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_league-diamond`).checked = localStorage[`${prefix}_league-diamond`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_league-champion`).checked = localStorage[`${prefix}_league-champion`] === 'true' ? true : false;*/

    // Edition
    document.querySelector(`#${prefix}_edition-alpha`).checked = localStorage[`${prefix}_edition-alpha`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_edition-beta`).checked = localStorage[`${prefix}_edition-beta`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_edition-promo`).checked = localStorage[`${prefix}_edition-promo`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_edition-reward`).checked = localStorage[`${prefix}_edition-reward`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_edition-untamed`).checked = localStorage[`${prefix}_edition-untamed`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_edition-dice`).checked = localStorage[`${prefix}_edition-dice`] === 'true' ? true : false;
    //document.querySelector(`#${prefix}_edition-chaos`).checked = localStorage[`${prefix}_edition-chaos`] === 'true' ? true : false;

    // Rarity
    document.querySelector(`#${prefix}_common`).checked = localStorage[`${prefix}_common`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_rare`).checked = localStorage[`${prefix}_rare`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_epic`).checked = localStorage[`${prefix}_epic`] === 'true' ? true : false;
    document.querySelector(`#${prefix}_legendary`).checked = localStorage[`${prefix}_legendary`] === 'true' ? true : false;

    if (prefix === 'rent') {
        if (parseFloat(localStorage['rent_days']))
            document.querySelector('#rent_days').value = localStorage['rent_days'];
    }
}


export async function start_stream() {
    stream = store.hive_client.blockchain.getBlockStream({ mode: dhive.BlockchainMode.Latest });
    stream.on('data', function(block) {
        /*let received = new Date().toTimeString().substring(3,8);
        let created = block.timestamp.substring(14,19);
        let delay = parseFloat(received.substring(0,2)) * 60 + parseFloat(received.substring(3,5)) - parseFloat(created.substring(0,2)) * 60 - parseFloat(created.substring(3,5));
        console.log(`Received ${received} | Created ${created} | Dealy ${delay}s | ${block.block_id} | ${delay}`);*/
        block.transactions.forEach(trx => {
            if (trx.operations[0][0] === "custom_json") {
                let sp_trx = trx.operations[0][1];
                if (sp_trx.id === "sm_sell_cards") {    // list buy
                    add_to_watchlist('buy', sp_trx.json, true);
                } else if (sp_trx.id === "sm_market_list") {    // list rent
                    add_to_watchlist('rent', sp_trx.json, true);
                } else if (sp_trx.id === "sm_market_purchase") {    // purchase buy
                    process_sold_stream('buy', 'purchase', sp_trx.json);
                } else if (sp_trx.id === "sm_market_rent") {    // purchase rent
                    process_sold_stream('rent', 'purchase', sp_trx.json);
                } else if (sp_trx.id === "sm_cancel_sell") {    // cancel buy
                    process_sold_stream('buy', 'remove', sp_trx.json);
                } else if (sp_trx.id === "sm_market_cancel_rental") {   // cancel rent
                    process_sold_stream('rent', 'remove', sp_trx.json);
                }
            }
        });
    }).on('error', function() {
        start_stream()
    });
}


export async function login() {
    // Prevent user from logging multiple times
    if (store.user.username != "")
        return

    // Try with keychain
    try {
        window.hive_keychain.requestHandshake();
        hive_keychain.requestSignBuffer(store.user.username, "Log in", 'Posting', res => callback_login(res), null, "Log in");
        return store.user

    } catch (err) {
        alert("You need to install Hive Keychain. Go to https://hive-keychain.com");
    }
}


async function callback_login(res) {
    // Check if the result is coming back
    setTimeout(() => {
        if (res == undefined) {
            alert("Splinterlands data cannot be accessed.\nThis is not a problem of this website and the only thing we can do is wait.\nSorry for the inconvenience.");
            throw "No log in response after 10s";
        }
    }, 10000)

    if (res.error != null) {
        alert(`ERROR LOGGING IN: ${res.error}`);
        return;
    }

    store.user.username = res.data.username;

    const response = await update_balance();

    $('#btn_login').hide();
    $('#nav-username').text(store.user.username);
    $('#mobile-login').text(store.user.username);
    let font_size = parseFloat(window.getComputedStyle(document.body, null).getPropertyValue('font-size'));
    let width = window.innerWidth;
    let em = width / font_size;
    if (em > 56.25) {
        $('#nav-user').css({'display': 'flex'});
    }
}


async function update_balance() {
    // Get DEC price
    const settings = await (await fetch("https://api.splinterlands.io/settings")).json();
    store.usd_dec = settings.dec_price;

    // Get player balance
    let player_dec = 0;
    const balance = await (await fetch("https://api.splinterlands.io/players/balances?username="+store.user.username)).json();
    balance.forEach(obj => {
        store.user.balance[obj.token] = obj.balance
    });

    $('#nav-balance-credits').text(`${beautify_number(store.user.balance['CREDITS'])} CREDITS`);
    $('#nav-balance-dec').text(`${beautify_number(store.user.balance['DEC'])} DEC`);
    $('#nav-balance-sps').text(`${beautify_number(store.user.balance['SPS'])} SPS`);
}


function beautify_number(num) {
    const order = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" }
    ];
    num = Math.round(num);
    let digits = num.toString().length;

    for (digits; digits - 3 >= 0; digits-=3) {}

    if (digits % 3 == 0)
        digits = 0;
    else if (digits % 2 == 0)
        digits = 1;
    else
        digits = 3;

        const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
        var item = order.slice().reverse().find(function(item) {
            return num >= item.value;
        });
        return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}


async function get_hashed_grouped_market(type) {
    let url = type == 'buy' ? "https://api.splinterlands.io/market/for_sale_grouped" : "https://api2.splinterlands.com/market/for_rent_grouped";
try {
    const response = await fetch(url);
    const data = await response.json();

    let market = [];
    data.forEach(card => {
        market[type + "&id="+card.card_detail_id+"&gold="+card.gold+"&edition="+card.edition] = card;
    });
    return market;
} catch (err) { console.log(err); }
}


export async function refresh_reference() {
    store.reference_grouped['buy'] = await get_hashed_grouped_market('buy');
    store.reference_grouped['rent'] = await get_hashed_grouped_market('rent');
}


function string_to_date(str) {
    return new Date(str.substring(0,4), str.substring(5,7)-1, str.substring(8,10), str.substring(11,13), str.substring(14,16), str.substring(17,19));
}


function strings_to_dates(str_arr) {
    let dates = [];
    str_arr.forEach(str => {
        dates.push(string_to_date(str));
    });
    return dates;
}


export async function update_usd_dec() {
    const settings = await (await fetch("https://api.splinterlands.io/settings")).json();
    store.usd_dec = settings.dec_price;
}


// Should make it recursive with setTimeout()
// If left like this if a call uses more than 3 sec a second call could finish exectuing before the first one
// There should be a promise await all and then recursion
export async function new_refresh_watchlist() {
    const data = await get_data(100);
    const list_buy = data[0];
    const list_rent = data[1];
    const sold_buy = data[2];
    const sold_rent = data[3];
    const cancel_buy = data[4];
    const cancel_rent = data[5];

    const process_list_buy = process_listings('buy', list_buy);
    const process_list_rent = process_listings('rent', list_rent);
    const process_sold_buy = process_sold('buy', 'purchase', sold_buy);
    const process_sold_rent = process_sold('rent', 'purchase', sold_rent);
    const process_cancel_buy = process_sold('buy', 'remove', cancel_buy);
    const process_cancel_rent = process_sold('rent', 'remove', cancel_rent);
}


async function get_data(num) {
    //cancel_sell market_cancel_rental
    //try {
    const promise_buy = fetch("https://api.steemmonsters.io/transactions/history?types=sell_cards&limit="+num);
    const promise_rent = fetch("https://api.steemmonsters.io/transactions/history?types=market_list&limit="+num);
    const promise_sold = fetch("https://api.steemmonsters.io/transactions/history?types=market_purchase&limit="+num);
    const promise_rented = fetch("https://api.steemmonsters.io/transactions/history?types=market_rent&limit="+num);
    const promise_cancel_buy = fetch("https://api.steemmonsters.io/transactions/history?types=cancel_sell&limit="+num);
    const promise_cancel_rent = fetch("https://api.steemmonsters.io/transactions/history?types=market_cancel_rental&limit="+num);

    const promises = await Promise.all([promise_buy, promise_rent, promise_sold, promise_rented, promise_cancel_buy, promise_cancel_rent]);
    const jsons = await Promise.all([promises[0].json(), promises[1].json(), promises[2].json(), promises[3].json(), promises[4].json(), promises[5].json()]);

    /*let received = new Date().toTimeString().substring(3,8);
    let created = jsons[0][0].created_date.substring(14,19);
    let delay = parseFloat(received.substring(0,2)) * 60 + parseFloat(received.substring(3,5)) - parseFloat(created.substring(0,2)) * 60 - parseFloat(created.substring(3,5));
    console.log(`Received ${received} | Created ${created} | Dealy ${delay}s | ${jsons[0][0].block_id} | ${delay}`);*/

    return jsons;
    //} catch (err) { console.log(err); }
}


// Define an arbitrary reference date in the past and find the minimum difference
function find_most_recent(dates) {
    const ref = new Date(2021, 8, 20, 15, 42, 12);  // Reference date
    let min = dates[0] - ref;   // Minimum value
    let idx = 0;    // Index of the minimum
    for (var i = 1; i < dates.length; i++) {
        if (dates[i] - ref < min) {
            min = dates[i] - ref;
            idx = i;
        }
    }
    return i;
}


async function process_listings(buy_rent, listings) {
    const newest_date = string_to_date(listings[0].created_date); // what for?
    const list_type = 'list_' + buy_rent;

    for(let i = 0; i < listings.length; i++) {
        // Check if the current listing was created before the newest in the last batch
        if (is_new(list_type, listings[i].created_date, newest_date) == false) {
            //console.log(list_type + " " + i);
            return;
        }

        const adder = await add_to_watchlist(buy_rent, listings[i]);
    }
}


function process_sold(buy_rent, purchase_remove, sold) {
    const newest_date = string_to_date(sold[0].created_date);
    const list_type = 'sold_' + buy_rent;

    for (let i = 0; i < sold.length; i++) {
        // Check if the current listing was created before the newest in the last batch
        if (is_new(list_type, sold[i].created_date, newest_date) == false) {
            //console.log(list_type + " " + i);
            return;
        }

        let items;
        if (buy_rent === 'buy' && purchase_remove === 'remove')
            items = JSON.parse(sold[i].data).trx_ids;
        else
            items = JSON.parse(sold[i].data).items;

        items.forEach(market_id => {
            if (store.market_map[market_id] != undefined) {
                // Remove item from list
                $("tr[data-hash='"+store.market_map[market_id]+"']").remove();
                // Reset market_map
                store.market_map[market_id] = undefined;
            }
        });
    }
}


function process_sold_stream(buy_rent, purchase_remove, sold) {
    let items;
    if (buy_rent === 'buy' && purchase_remove === 'remove')
        items = JSON.parse(sold).trx_ids;
    else
        items = JSON.parse(sold).items;
    items.forEach(market_id => {
        if (store.market_map[market_id] != undefined) {
            // Remove item from list
            $("tr[data-hash='"+store.market_map[market_id]+"']").remove();
            // Reset market_map
            store.market_map[market_id] = undefined;
        }
    });
}


function is_new(hash, current_date, newest_date) {
    if (string_to_date(current_date) - store.last_dates[hash] < 0) {
        update_refresh_num(hash);
        store.last_dates[hash] = newest_date;
        return false;
    }
    return true;
}


function update_refresh_num(num_hash) {

}


// TODO implement faster way from https://api.steemmonsters.io/transactions/history?from_block=56807666&types=sell_cards // &limit=250
//                             or https://api.splinterlands.io/transactions/history?from_block=56807666types=sell_cards
/*async function refresh_watchlist(buy_rent) {
    const head = await get_latest_block();
    //const response = await fetch("https://api.splinterlands.io/transactions/history?from_block="+(head-14));
    //const response = await fetch("https://api.splinterlands.io/transactions/history?from_block=56807646");
    const response = await fetch("https://api.steemmonsters.io/transactions/history?types=sell_cards&limit=75");
    const history = await response.json();
    const listings_type = buy_rent == 'buy' ? 'sell_cards' : 'market_list';
    const purchase_type = buy_rent == 'buy' ? 'market_purchase' : 'market_rent';
    let listings = [];
    let purchases = [];
    //let types = [];

    let current_date = string_to_date(history[0].created_date);
    //console.log(current_date + " - " + store.last_dates[buy_rent])
    console.log(current_date - store.last_dates[buy_rent]);
    store.last_dates[buy_rent] = current_date;

    for (let i = 0; i < history.length; i++) {
        if (history[i].type == listings_type) {
            listings.push(history[i]);
        } else if (history[i].type == purchase_type) {
            purchases.push(history[i]);
        }
        //if (types[history[i].type] == undefined)
        //    types[history[i].type] = history[i].type;
    } //console.log(JSON.parse(purchases[0].data));
    //console.log(types);
    //console.log(listings)

    listings.forEach(listing => {
        //console.log(listing);
        add_to_watchlist(buy_rent, listing);
    });

    // market id = JSON.parse(purchases[i].data).items[j]
    purchases.forEach(purchase => {
        let items = JSON.parse(purchase.data).items;
        items.forEach(market_id => {
            if (store.market_map[market_id] != undefined) {
                //console.log(market_id + "was sold " + store.watchlist[store.market_map[market_id]]);
                // Remove item from list
                $("tr[data-hash='"+store.market_map[market_id]+"']").remove();
                // Reset market_map
                store.market_map[market_id] = undefined;
            }
        });
    });
}*/


function get_latest_block() {
    return new Promise((resolve, reject) => {
        hive.api.getDynamicGlobalProperties(function(err, result) {
            resolve(result.head_block_number);
            reject(err);
        });
    });
}


export async function add_to_watchlist(buy_rent, listing, streaming = false) {
    let data = streaming == false ? JSON.parse(listing.data) : JSON.parse(listing);
    let ids = new Array(data.length);
    if (buy_rent == 'buy') {
        for (let i = 0; i < data.length; i++) {
            ids[i] = data[i].cards[0];
        }
    } else {
        for (let i = 0; i < data.cards.length; i++) {
            ids[i] = data.cards[i][0];
        }
    }

    const cards_info = await (await fetch("https://api.splinterlands.io/cards/find?ids="+ids)).json();
    //console.log(cards_info);

    for (let i = 0; i < cards_info.length; i++) {
        let card_detail_id = cards_info[i].card_detail_id;
        let gold = cards_info[i].gold;
        let edition = cards_info[i].edition;
        let hash = buy_rent + "&id="+card_detail_id+"&gold="+gold+"&edition="+edition;
        let rarity = cards_info[i].details.rarity;
        let bcx = get_bcx(cards_info[i].xp, card_detail_id, gold, edition, rarity, cards_info[i].details.tier).toFixed(0);
        let price;
        let ref_price;

        if (cards_info[i].buy_price == null) {
            continue; /////////////////////////////
        }

        price = parseFloat(cards_info[i].buy_price);
        //try {
            if (bcx > 1)
                ref_price = store.reference_grouped[buy_rent][hash].low_price_bcx * bcx;
            else
                ref_price = store.reference_grouped[buy_rent][hash].low_price;
        //} catch { return; } // Skip errors when new cards are injected in the market

        let change = 100 * (price - ref_price) / ref_price;
        change = change.toFixed(1);

        if (change == 0) //??? No need | YES NEEDED or previous price gets updated
            continue;

        if (price >= ref_price)
            continue;

        if (!filter(buy_rent, change, price, gold, edition, rarity))
            continue;

        if ($('#'+buy_rent+'_sound-alert').prop('checked') == true)
            store.audio['alert'].play();

        if (store.watchlist[hash] == undefined) {
            store.watchlist[hash] = {
                'uid': cards_info[i].uid,
                'market_id': cards_info[i].market_id,
                'card_detail_id': card_detail_id,
                'gold': gold,
                'edition': edition,
                'name': cards_info[i].details.name,
                'rarity': rarity,
                'bcx': bcx,
                'price': price,
                'previous': ref_price,
                'change': change,
                'power': calculateCP(cards_info[i]) // get_power(card_detail_id, edition, rarity, gold, bcx)
            }
        } else {
            $("tr[data-hash='"+hash+"']").remove();
            store.watchlist[hash].previous = ref_price;
            store.watchlist[hash].uid = cards_info[i].uid;
            store.watchlist[hash].market_id = cards_info[i].market_id;
            store.watchlist[hash].price = price;
            store.watchlist[hash].bcx = bcx;
            store.watchlist[hash].change = change;
        }
        // Update market map for quick search by market_id
        store.market_map[cards_info[i].market_id] = hash;           // HERE TO SUPPORT MULTIPLE CARDS
        // Update reference price
        //if (buy_rent == 'buy')
        if (bcx == 1)
            store.reference_grouped[buy_rent][hash].low_price = price;
        else
            store.reference_grouped[buy_rent][hash].low_price_bcx = price / bcx;
        //else
        //    store.reference_grouped_rent[hash].low_price = price;
        draw_table_item(buy_rent, store.watchlist[hash], hash);
    }
    //const cards = await Promise.all([])
}


function draw_table_item(buy_rent, item, hash) {
    let gold_path = item.gold == false ? "foil_standard.png" : "foil_gold.png";
    let img_name = item.name.replace(/\s/g, "%20");
    let img_gold = item.gold ? "_gold" : "";

    let previous_or_dec;
    let price;
    let power_col = buy_rent === 'buy' ? "" : "<td>"+ item.power +"</td>";
    let xp_col = '<td>' + item.bcx + '</td>';
    let is_rent_vanish = '';
    let is_buy_vanish = '';

    if (buy_rent === 'buy') {
        price = item.price;
        previous_or_dec = item.previous.toFixed(2);
        if (item.bcx > 1)
            previous_or_dec = "~" + previous_or_dec;
        is_buy_vanish = 'class="vanish"';
    } else {
        price = (item.price * store.usd_dec).toFixed(4);
        previous_or_dec = item.price;
        power_col = '<td>' + beautify_number(item.power) + '</td>'; //beautify_number(item.power)
        is_rent_vanish = 'class="vanish"';
    }

    let add = '';
    // Hash and market ID
    add = '<tr data-hash="'+ hash +'" data-market="' + item.market_id + '" class="floating-card--trigger">' +
    // Name
    '<td class="floating-card--trigger">' + item.name +
    // Floating card
    '<div class="floating-card--container"><img src="https://d36mxiodymuqjm.cloudfront.net/cards_by_level/' + get_edition(item.edition) + '/' + img_name + '_lv1' + img_gold + '.png"></div></td>' +
    // Gold
    '<td><img  class="market-table__icon" src="img/' + gold_path + '"></td>' +
    // Edition
    '<td class="vanish"><img  class="market-table__icon" src="img/'+ get_edition(item.edition) + '.png"></td>' +
    // Rarity
    '<td class="vanish"><img  class="market-table__icon" src="img/' + get_rarity(item.rarity) + '.png"></td>' +
    // BCX
    xp_col +
    // Power
    power_col +
    // Price USD
    '<td>' + price + '</td>' +
    // Previous/Next - Price DEC
    '<td class="vanish">' + previous_or_dec + '</td>' +
    // Change
    '<td ' + is_rent_vanish + '>' + item.change + '%</td></tr>';

    // Add to html
    if (buy_rent == 'buy')
        $('#watchlist_buy tbody').prepend($(add));
    else
        $('#watchlist_rent tbody').prepend($(add));

    // Event handler
    $("tr[data-hash='"+hash+"']").on('click', event => {
        let element;
        // Find element with the data-hash parameter
        if ($(event.target).attr("data-hash") == undefined) {
            if (element = $(event.target).parent().attr("data-hash") == undefined) {
                element = $(event.target).parent().parent();
            } else {
                element = $(event.target).parent();
            }

        } else {
            element = $(event.target);
        }
        // Call buy functions
        if (buy_rent == 'buy')
            buy_card([element.attr("data-market")], store.watchlist[element.attr("data-hash")].price);
        else
            rent_card([element.attr("data-market")], store.watchlist[element.attr("data-hash")].price);
     });
}


function filter(buy_rent, change, price, gold, edition, rarity) {
    let actual_price = buy_rent === 'buy' ? price : price * store.usd_dec;

    // Change
    if ($('#'+buy_rent+'_filter-change').prop('checked') == true) {
        let min_change = $('#'+buy_rent+'_filter-change-min').val();
        if (-Math.abs(min_change) < change && min_change != "")
            return false;
    }

    // Price
    if ($('#'+buy_rent+'_filter-price').prop('checked') == true) {
        let min_price = $('#'+buy_rent+'_filter-price-min').val();
        let max_price = $('#'+buy_rent+'_filter-price-max').val();

        if (min_price != "" && max_price != "") {
            if (actual_price < min_price || actual_price > max_price) {
                //console.log(`${min_price} < ${actual_price} < ${max_price}`)
                return false;
            }
        }
    }

    // Foil
    let filter_standard = $('#'+buy_rent+'_foil-standard').prop('checked');
    let filter_gold = $('#'+buy_rent+'_foil-gold').prop('checked');
    // if both checked or unchecked no need to filter
    if (filter_standard != filter_gold) {
        if (filter_standard == false && gold == false)
            return false;
        if (filter_gold == false && gold == true)
            return false;
    }

    // Rarity
    let filter_rarity = [
        $('#'+buy_rent+'_common').prop('checked'),
        $('#'+buy_rent+'_rare').prop('checked'),
        $('#'+buy_rent+'_epic').prop('checked'),
        $('#'+buy_rent+'_legendary').prop('checked')
    ];
    if (needs_filtering(filter_rarity) && filter_rarity[rarity-1] == false)
        return false;

    // Edition
    let filter_league = [
        $('#'+buy_rent+'_league-bronze').prop('checked'),
        $('#'+buy_rent+'_league-silver').prop('checked'),
        $('#'+buy_rent+'_league-gold').prop('checked'),
        $('#'+buy_rent+'_league-diamond').prop('checked'),
        $('#'+buy_rent+'_league-champion').prop('checked'),
    ];
    if (needs_filtering(filter_league) && filter_league[edition] == false) /////////////////////
        return false;

    // Edition
    let filter_edition = [
        $('#'+buy_rent+'_edition-alpha').prop('checked'),
        $('#'+buy_rent+'_edition-beta').prop('checked'),
        $('#'+buy_rent+'_edition-promo').prop('checked'),
        $('#'+buy_rent+'_edition-reward').prop('checked'),
        $('#'+buy_rent+'_edition-untamed').prop('checked'),
        $('#'+buy_rent+'_edition-dice').prop('checked'),
        //$('#'+buy_rent+'_edition-chaos').prop('checked')
    ];
    if (needs_filtering(filter_edition) && filter_edition[edition] == false)
        return false;

    return true;
}


function needs_filtering(arr) {
    let needs = false;
    for (let i = 1; i < arr.length; i++) {
        if (arr[0] != arr[i]) {
            needs = true;
            break;
        }
    }
    return needs;
}


function get_edition(edition_id) {
    switch (edition_id) {
        case 0:
            return "alpha";
        case 1:
            return "beta";
        case 2:
            return "promo";
        case 3:
            return "reward";
        case 4:
            return "untamed"
        case 5:
            return "dice";
        case 6:
            return "gladius";
    }
}


function get_rarity(rarity_id) {
    switch (rarity_id) {
        case 1:
            return "common";
        case 2:
            return "rare";
        case 3:
            return "epic";
        case 4:
            return "legendary";
    }
}


function get_bcx(xp, card_detail_id, gold, edition, rarity, tier) {
	if(edition == 4 || tier >= 4) return xp;
	var xp_property = edition == 0 || edition == 2 && card_detail_id < 100 ? gold ? "gold_xp" : "alpha_xp" : gold ? "beta_gold_xp" : "beta_xp";
	var bcx_xp = store.settings[xp_property][rarity - 1];
    //console.log(`${xp} | ${get_edition(edition)} | ${Math.max(gold ? xp / bcx_xp : (xp + bcx_xp) / bcx_xp, 1)}`)
	return Math.max(gold ? xp / bcx_xp : (xp + bcx_xp) / bcx_xp, 1)
}


function getLevel(xp, rarity) {
	for(var i = 0; i < SM.settings.xp_levels[rarity - 1].length; i++) {
		if(xp < SM.settings.xp_levels[rarity - 1][i]) return i + 1
	}
	return SM.settings.xp_levels[rarity - 1].length + 1
}


function get_level(rarity_id, xp) {
    let edges;

    switch (rarity_id) {
        case 1:
            edges = [1, 5, 14, 30, 60, 100, 150, 220, 300, 400];
            break;
        case 2:
            edges = [1, 5, 14, 25, 40, 60, 85, 115];
            break;
        case 3:
            edges = [1, 4, 10, 20, 32, 46];
            break;
        case 4:
            edges = [1, 3, 6, 11];
            break;
    }

    let level = edges.length;

    console.log(edges)
    for (let i = 1; i < edges.length; i++) {
        if (xp >= edges[i-1] && xp < edges[i])
            level = i;
    }

    console.log(level)
    return level;
}


function get_power(card_detail_id, edition, rarity, gold, bcx) {
    let pow_edition;
    let pow_rariry;
    let pow_foil ;

    if (edition == 0 || edition == 2)
        pow_edition = 30;
    else if (edition == 1 || (edition == 3 && card_detail_id < 135))
        pow_edition = 15;
    else if (edition == 4 || edition == 5 || (edition == 3 && card_detail_id > 135 && card_detail_id < 299))
        pow_edition = 10;
    else if (edition == 6 || (edition == 3 && card_detail_id > 298))
        pow_edition = 5;

    switch (rarity) {
        case 1:
            pow_rariry = 1;
            break;
        case 2:
            pow_rariry = 4;
            break;
        case 3:
            pow_rariry = 20;
            break;
        case 4:
            pow_rariry = 100;
            break;
    }

    if (gold && card_detail_id > 298)
        pow_foil = 25;
    else if (gold)
        pow_foil = 50;
    else
        pow_foil = 1;

    //console.log(`${pow_edition} * ${pow_rariry} * ${pow_foil} = ${pow_edition * pow_rariry * pow_foil}`);
    return pow_edition * pow_rariry * pow_foil * bcx;
}


function calculateCP(card) {
	var details = card.details; // var details = SM.GetCardDetails(card.card_detail_id);
	var alpha_bcx = 0,
		alpha_dec = 0;
	var xp = Math.max(card.xp - card.alpha_xp, 0);
	let burn_rate = card.edition == 4 || details.tier >= 4 ? store.settings['dec'].untamed_burn_rate[details.rarity - 1] : store.settings['dec'].burn_rate[details.rarity - 1];
	if(card.alpha_xp) {
		var alpha_bcx_xp = store.settings[card.gold ? "gold_xp" : "alpha_xp"][details.rarity - 1];
		alpha_bcx = Math.max(card.gold ? card.alpha_xp / alpha_bcx_xp : card.alpha_xp / alpha_bcx_xp, 1);
		alpha_dec = burn_rate * alpha_bcx * store.settings['dec'].alpha_burn_bonus;
		if(card.gold) alpha_dec *= store.settings['dec'].gold_burn_bonus
	}
	var xp_property = card.edition == 0 || card.edition == 2 && details.id < 100 ? card.gold ? "gold_xp" : "alpha_xp" : card.gold ? "beta_gold_xp" : "beta_xp";
	var bcx_xp = store.settings[xp_property][details.rarity - 1];
	var bcx = Math.max(card.gold ? xp / bcx_xp : (xp + bcx_xp) / bcx_xp, 1);
	if(card.edition == 4 || details.tier >= 4) bcx = card.xp;
	if(card.alpha_xp) bcx--;
	var dec = burn_rate * bcx;
	if(card.gold) {
		const gold_burn_bonus_prop = details.tier >= 7 ? "gold_burn_bonus_2" : "gold_burn_bonus";
		dec *= store.settings['dec'][gold_burn_bonus_prop]
	}
	if(card.edition == 0) dec *= store.settings['dec'].alpha_burn_bonus;
	if(card.edition == 2) dec *= store.settings['dec'].promo_burn_bonus;
	var total_dec = dec + alpha_dec;
	if(card.xp >= getMaxXp(details, card.edition, card.gold)) total_dec *= store.settings['dec'].max_burn_bonus;
	if(details.tier >= 7) total_dec = total_dec / 2;
	return total_dec
}


function getMaxXp(details, edition, gold) {
	let rarity = details.rarity;
	let tier = details.tier;
	if(edition == 4 || tier >= 4) {
		let rates = gold ? store.settings['combine_rates_gold'][rarity - 1] : store.settings['combine_rates'][rarity - 1];
		return rates[rates.length - 1]
	} else return store.settings['xp_levels'][rarity - 1][store.settings['xp_levels'][rarity - 1].length - 1]
}


function table_click(event, buy_rent, element) {
    //buy_cards(buy_rent, [$(element).attr("data-market")], watchlist[$(element).attr("data-hash")].price)
    //buy_cards(buy_rent, [$(this).attr("data-market")], store.watchlist[$(this).attr("data-hash")].price)
}


/*export async function buy_cards(buy_rent, market_id, price_usd, account=null) {
    const settings = await (await fetch("https://api.splinterlands.io/settings")).json();
    const usd_dec = settings.dec_price;
    const price_dec = price_usd / usd_dec;

    // Check for log in
    if (store.user.username == "") {
        alert("You need to log in first!");
        return;
    }

    // Check if user has enough money
    const balance = await update_balance();
    if (store.user.balance['DEC'] <= price_dec)
        alert(`ERROR: ${store.user.username} doesn't have enough DEC`);
    //const balance = await (await fetch("https://api.splinterlands.io/players/balances?username="+store.user.username)).json();
    //balance.forEach(obj => {
    //    if (obj.token == "DEC") {
    //        if (obj.balance <= price_dec)
    //            alert(`ERROR: ${store.user.username} doesn't have enough DEC`);
    //    }
    //});

    let key = 'Active';
    let id = 'sm_market_purchase';
    var json = {
        items: market_id,
        price: price_dec,
        currency: "DEC",
        market: "splinteralert",
        app: "splinteralert"
    }
    json = JSON.stringify(json);

    hive_keychain.requestCustomJson(account, id, key, json, `Buy item for ${price_usd}$, around ${Math.round(price_usd/usd_dec)} DEC`, res => {
        if (res.error != null)
            alert(res.error);
        else if (res.error == null) {
            let watchlist_item = store.watchlist[store.market_map[market_id]];
            let ga_obj = {
                currency: "USD",
                value: price_usd * 0.05,
                price_usd: price_usd,
                previous_usd: watchlist_item.previous,
                currency_name: "DEC",
                currency_amount: price_usd / usd_dec,
                transaction_id: res.result['id'],
                discount: watchlist_item.previous - price_usd,
                change: parseFloat(watchlist_item.change),
                xp: watchlist_item.xp,
                rarity: watchlist_item.rarity,
                gold: watchlist_item.gold ? 1 : 0,
                edition: watchlist_item.edition,
                card_detail_id: watchlist_item.card_detail_id,
                items: [
                    {
                        item_id: watchlist_item.card_detail_id,
                        item_name: watchlist_item.name
                    }
                ]
            };

            let interval = setInterval( function() { check_transaction_old(market_id, interval, ga_obj) }, 1000);
        }
    });
}*/


async function buy_card(market_id, price_usd) {
    // Check for log in
    /*if (store.user.username == "") {
        alert("You need to log in first!");
        return;
    }*/

    var currency = $('#buy_currency-dec').prop('checked') ? "DEC" : "CREDITS";
    let price = await get_buy_price(currency, price_usd);
    let message;

    if (currency === "DEC")
        message = `Buy card for ${price_usd}$, around ${Math.round(price)} DEC`;
    else
        message = `Buy card for ${price_usd * 1000} CREDITS`;

    // Check if user has enough money
    /*let enough_money = await check_balance(currency, price);
    if (enough_money == false) {
        alert(`ERROR: ${store.user.username} doesn't have enough ${currency}`);
        return;
    }*/

    let key = 'Active';
    let id = 'sm_market_purchase';
    var json = {
        items: market_id,
        price: price,
        currency: currency,
        market: "splinteralert",
        app: "splinteralert"
    }
    json = JSON.stringify(json);


    hive_keychain.requestCustomJson("", id, key, json, message, res => {
        if (res.error != 'user_cancel' && res.error != null)
            alert(res.error);
        else if (res.error == null) {
            popup_show("Checking your transaction");
            let ga_obj = build_ga('buy', currency, price, price_usd, market_id, res);
            let interval = setInterval( function() { check_transaction(res.result['id'], interval, ga_obj) }, 1000);
        }
    });
}


// NOW PROBABLY DON"T EVEN NEED TO CHECK IF HAS ENOUGH MONEY
async function rent_card(market_id, price_dec) {
    // Check for log in
    /*if (store.user.username == "") {
        alert("You need to log in first!");
        return;
    }*/

    var currency = $('#rent_currency-dec').prop('checked') ? "DEC" : "CREDITS";
    var rent_days = $('#rent_days').val();
    let price = await get_rent_price(currency, price_dec);
    let message = "";

    if (currency === "DEC")
        message = `Rent card for ${rent_days} days for a total of ${(price * rent_days).toFixed(3)} DEC, around ${(price * store.usd_dec * rent_days).toFixed(4)}$`;
    else
        message = `Rent card for ${rent_days} days for a total of around ${(price * store.usd_dec * rent_days * 1000).toFixed(2)} CREDITS`;

    // Check if user has enough money
    /*let enough_money = await check_balance(currency, price, rent_days);
    if (enough_money == false) {
        alert(`ERROR: ${store.user.username} doesn't have enough ${currency}`);
        return;
    }*/

    let key = 'Active';
    let id = 'sm_market_rent';
    var json = {
        items: market_id,
        currency: currency,
        days: rent_days,
        market: "splinteralert",
        app: "splinteralert"
    }
    json = JSON.stringify(json);

    hive_keychain.requestCustomJson("", id, key, json, message, res => {
        if (res.error != 'user_cancel' && res.error != null)
            alert(res.error);
        else if (res.error == null) {
            popup_show("Checking your transaction");
            let price_usd = currency == "DEC" ? price * store.usd_dec : price;
            let ga_obj = build_ga('rent', currency, price, price_usd, market_id, res);
            let interval = setInterval( function() { check_transaction(res.result['id'], interval, ga_obj) }, 1000);
            //let interval = setInterval( function() { check_transaction(market_id, interval, ga_obj) }, 1000);
        }
    });
}


async function check_balance(currency, price, rent_days = 1) {
    const balance = await update_balance();
    if (store.user.balance[currency] <= price * rent_days)
        return false;

    return true;
}

async function get_buy_price(currency, price_usd) {
    if (currency == "DEC") {
        const settings = await (await fetch("https://api.splinterlands.io/settings")).json();
        const usd_dec = settings.dec_price;
        return price_usd / usd_dec;
    } else if (currency == "CREDITS") {
        return price_usd;
    }
}


async function get_rent_price(currency, price_dec) {
    if (currency == "DEC") {
        return price_dec;
    } else if (currency == "CREDITS") {
        const settings = await (await fetch("https://api.splinterlands.io/settings")).json();
        const usd_dec = settings.dec_price;
        return price_dec * usd_dec;
    }
}


function build_ga(buy_rent, currency, price, price_usd, market_id, res) {
    let watchlist_item = store.watchlist[store.market_map[market_id]];
    return {
        currency: "USD",
        value: price_usd * 0.05,
        price_usd: price_usd,
        previous_usd: watchlist_item.previous,
        currency_name: currency,
        currency_amount: price,
        transaction_id: res.result['id'],
        discount: watchlist_item.previous - price_usd,
        change: parseFloat(watchlist_item.change),
        xp: watchlist_item.xp,
        rarity: watchlist_item.rarity,
        gold: watchlist_item.gold ? 1 : 0,
        edition: watchlist_item.edition,
        card_detail_id: watchlist_item.card_detail_id,
        buy: buy_rent == 'buy' ? 1 : 0,
        rent: buy_rent == 'buy' ? 0 : 1,
        items: [
            {
                item_id: watchlist_item.card_detail_id,
                item_name: watchlist_item.name
            }
        ]
    };
}


async function get_usd(currency, price) {
    if (currency == "DEC") {
        const settings = await (await fetch("https://api.splinterlands.io/settings")).json();
        const usd_dec = settings.dec_price;
        return price * usd_dec;
    } else if (currency == "CREDITS") {
        return price;
    }
}


async function check_transaction_old(market_id, interval, ga_obj) {
    const transaction = await (await fetch("https://api.splinterlands.io/market/status?id="+market_id)).json();
    if (transaction.purchaser == store.user.username) {
        alert("SUCCESS");
        clearInterval(interval);
        update_balance();
        // Google analytics
        gtag("event", "purchase", ga_obj);

    } else if (transaction.purchaser != store.user.username && transaction.purchaser != null) {
        alert(`ERROR: This card was already taken by ${transaction.purchaser}`);
        clearInterval(interval);
    }
}

async function check_transaction(trx_id, interval, ga_obj) {
    const transaction = await (await fetch("https://api.splinterlands.io/transactions/lookup?trx_id="+trx_id)).json();
    try {
        if (transaction['trx_info']['success'] != undefined)
            clearInterval(interval);
            if (transaction['trx_info']['success'] == true) {
                store.audio['success'].play();
                popup_hide_after("Success!", "success", 3000);
                update_balance();
                // Google analytics
                gtag("event", "purchase", ga_obj);
            } else {
                store.audio['fail'].play();
                popup_hide_after("ERROR: your transaction was rejected", "error", 3000);
            }
    } catch (err) {}
}


export function popup_show(message) {
    $('#popup-message').text(message);
    $('#popup-loading').css({'display': 'inherit'});
    $('#popup-container').attr("class", "popup__container");
    document.querySelector('#popup-checkbox').checked = true;
}


export function popup_hide_after(message, type, after) {
    $('#popup-message').text(message);
    $('#popup-loading').css({'display': 'none'});
    $('#popup-container').addClass(`popup__${type}`);
    setTimeout(() => document.querySelector('#popup-checkbox').checked = false, after);
}



// Helpers
async function find_reward_pivots() {
    let url = "https://api.splinterlands.io/cards/get_details";
    const response = await fetch(url);
    const data = await response.json();

    let pivots = [];

    for (let i = 0; i < data.length; i++) {
        /*if (data[i].editions == 3 && data[i-1].editions != 3) {
            pivots.push(`${data[i].id}  ${data[i].name}  ${data[i-1].editions}`)
        }*/
        console.log(`${data[i].id}  ${data[i].name}  ${data[i].editions}`)
    }

    pivots.forEach(reward => {
        console.log(reward)
    });
}


async function test_pow() {
    console.clear();
    let ids = "C4-180-B4H3QEEVVK";// "C3-108-043A2P0UYO,C3-108-40YUGDJ8BK";
    const cards_info = await (await fetch("https://api.splinterlands.io/cards/find?ids="+ids)).json();

    for (let i = 0; i < cards_info.length; i++) {
        console.log(`${cards_info[i].uid} | ${calculateCP(cards_info[i])}`);
    }


}